<template>
  <div class="mt-6 rounded-2xl border border-gray-100 bg-white p-5">
    <p class="text-sm font-bold text-rose-600">Bank Details for Payment:</p>
    <div
      v-for="(acc, i) in accounts"
      :key="i"
      class="mt-3 flex flex-col items-start justify-between gap-4 sm:flex-row"
      :class="{ 'border-t border-gray-100 pt-3': i > 0 }"
    >
      <div class="space-y-0.5 text-sm text-gray-800">
        <p><span class="font-bold">Bank Name:</span> {{ acc.bankName }}</p>
        <p><span class="font-bold">Account Title:</span> {{ acc.accountTitle }}</p>
        <p><span class="font-bold">Account Number:</span> {{ acc.accountNumber }}</p>
        <p><span class="font-bold">IBAN Number:</span> {{ acc.iban }}</p>
      </div>
      <div class="flex-shrink-0 text-center">
        <img v-if="qrImages[i]" :src="qrImages[i]" alt="Scan to copy bank details" class="h-20 w-20" />
        <p class="mt-1 text-[9px] uppercase tracking-wide text-gray-400">Scan to copy</p>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { BANK_ACCOUNTS } from '../data/bankAccounts'

export default {
  name: 'PrintBankDetails',
  data() {
    return {
      accounts: BANK_ACCOUNTS,
      qrImages: []
    }
  },
  async mounted() {
    this.qrImages = await Promise.all(
      this.accounts.map(acc => {
        const text = `Bank: ${acc.bankName}\nAccount Title: ${acc.accountTitle}\nAccount Number: ${acc.accountNumber}\nIBAN: ${acc.iban}`
        return QRCode.toDataURL(text, { width: 160, margin: 1 })
      })
    )
  }
}
</script>
